export const ActionNames = {
    EXTENRAINTERFACE: 'extenrainterface',
    GETCUSTOMER: 'getCustomer',
    MOBILENUMBER: 'MobileNumber',
    GETCUSTOMERVEHICLELIST: 'getCustomerVehicleList',
    SERVICES: 'Services',
    DEALERS: 'Dealers',
    RENTALCARS: 'RentalCars',
    GETAPPOINTMENTDATES: '',
    SAVEORDER: '',
    VERIFYOTP: 'VerifyOTP',
    SMS: 'sms',
    SENDOTP: 'SendOtp',
    APPOINTMENT: 'appointment',
    CHECKAVABLITY: 'CheckAvailabilityDates',
    ADD: 'AddAppointment',
    PACKAGE: 'GetPackageDetail',
    DEALERCONFIGURATION:'DealerConfiguration',
    BRAND:'Brands',
    MODELS:'Models',
    MPOADDITIONALSERVICE:'AdditionalPackages',
    GETUPSELLDATABYBRAND: 'GetUpSellDataByCode',
    MECHANICSDATA:'MechanicsCalendePlanner',
    RECALLDETAIL:'RecallDetail',
    DEALERIMAGE: 'DealerImage',
    GETMODELPDF: 'getModelPDF',
    GETDEALERBYDMSID: 'getDealerByDmsId',
    BRANDMPDEL: 'BrandModel',
    ACCESSORIES: 'accessories',
    GETACCESSORIES: 'getBydealerId',
    CUSTOMERS: 'Customers',
    GETMYSITEPARAM: 'MySiteParams',
    GETGIFTCARDBYPHONE: 'GetGiftCardByPhone',
    GETMINBILCONSNET: 'getMinBilConsent',
    UPDATEMINBILCONSNET: 'updateMinBilConsent',
    SENDREGISTRATIONEMAIL: 'sendRegistrationEmail',
    MECHANICSSPLITDATA:'MechanicsSplitCalendePlanner',
};
